import React from 'react'
import Styles from './About.module.less'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames/bind';

const cx = classnames.bind(Styles)
const Index = (props) => {
  const { t, i18n } = useTranslation()
  
  return (
    <div className={cx('about-page', {'about-page__foreign': i18n.language !== 'zh' })}>
      <div className="about-page_head"></div>
      <div className="about-page_content">
        <h3>{t('aboutUsArtical.titleArtical1')}</h3>
        <div className="about-page_artical">{t('aboutUsArtical.artical1a')}</div>
        <div className="about-page_artical">{t('aboutUsArtical.artical1b')}</div>
        <div className="about-page_gap"></div>
        <img className="margin" src="https://p5.ssl.qhimg.com/t012fd2527c18d6e5d6.png" alt="global target" />
        <div className="about-page_block">
          <h3>{t('aboutUsArtical.titleArtical2')}</h3>
          <div className="about-page_artical about-page_articalB">{t('aboutUsArtical.artical2a')}</div>
          <div className="about-page_artical">{t('aboutUsArtical.artical2b')}</div>
        </div>
        <div className="about-page_gap"></div>
        <div className="about-page_block margin">
          <h3>{t('aboutUsArtical.titleArtical3')}</h3>
          <div className="about-page_artical about-page_articalB">{t('aboutUsArtical.artical3a')}</div>
          <div className="about-page_artical">{t('aboutUsArtical.artical3b')}</div>
        </div>
        <img src="https://p3.ssl.qhimg.com/t01ee4e0960f02b6e1e.png" alt="company target" />
      </div>
    </div>
  )
}

export default Index
